import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App.js';
import './index.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Auth, ConfigProvider, Unauthorized, UserInit } from './base-ui/lib.js';
import { GlobalStateProvider } from './stateProviders/GlobalStateProvider.js';
import { CompanyStateProvider } from './stateProviders/CompanyStateProvider.js';
import { Login } from './pages/login/index.js';
import { LoginNavigationWrapper } from './loginNavigationWrapper.js';
import { PosthogWrapper } from './postHogWrapper.js';
import * as Sentry from '@sentry/react';
import CognitoLogin from './base-ui/Auth/cognitoLogin.js';
import Logout from './pages/logout/logout.js';
import { DocubeeTest } from './pages/deocubeeTest/docubeeTest.js';
import { ResetPassword } from './pages/resetPassword/ResetPassword.js';
import { SetPassword } from './pages/setPassword/SetPassword.js';
import { ThemeProvider } from './theme.tsx';

if (!process.env.REACT_APP_SENTRY_DSN) {
	console.error('REACT_APP_SENTRY_DSN is not set');
}

Sentry.init({
	dsn: process.env.REACT_APP_SENTRY_DSN,
	tracesSampleRate: 1.0,
	integrations: [Sentry.browserTracingIntegration()],
	environment: process.env.REACT_APP_ENVIRONMENT,
});

ReactDOM.createRoot(document.getElementById('root')!).render(
	<ThemeProvider>
		<ConfigProvider>
			<GlobalStateProvider>
				<CompanyStateProvider>
					<PosthogWrapper>
						<BrowserRouter>
							<Routes>
								<Route path="/unauthorized" element={<Unauthorized />} />
								<Route path="/user/init" element={<UserInit />} />
								<Route
									path="/login"
									element={
										<Auth
											LoginHeaderLogo={'/deck_metrix_logo.svg'}
											signInBackgroundColor="transparent"
										>
											<Login />
										</Auth>
									}
								/>
								<Route path="/cognito-login" element={<CognitoLogin />} />
								<Route path="/logout" element={<Logout />} />
								<Route path="/reset-password" element={<ResetPassword />} />
								<Route path="/set-password" element={<SetPassword />} />
								<Route path="/docubee/test" element={<DocubeeTest />} />
								<Route
									path="/*"
									element={
										<>
											<LoginNavigationWrapper>
												<App />
											</LoginNavigationWrapper>
										</>
									}
								/>
							</Routes>
						</BrowserRouter>
					</PosthogWrapper>
				</CompanyStateProvider>
			</GlobalStateProvider>
		</ConfigProvider>
	</ThemeProvider>
);
